/** @format */

const template = `
<sis-basic-grouping-panel
  heading="{{'CUSTOM_STUDY_DRAFT_SUMMARY.TITLE' | translate}} {{ $ctrl.customStudyDraft.name }},
    {{ $ctrl.customStudyDraft.credits | decimalNumber }} {{'CUSTOM_STUDY_DRAFT_SUMMARY.CREDITS_ABBR' | translate}}">
  <div class="form-group-mimic">
    <h4 translate="CUSTOM_STUDY_DRAFT_SUMMARY.LOCATION">Suunniteltu suorituspaikka</h4>
    <span>{{ $ctrl.customStudyDraft.location }}</span>
  </div>

  <div class="form-group-mimic">
    <h4 translate="CUSTOM_STUDY_DRAFT_SUMMARY.DESCRIPTION">Tavoiteltava osaaminen</h4>
    <span class="text-area-static">{{ $ctrl.customStudyDraft.description }}</span>
  </div>
</sis-basic-grouping-panel>
`;
export default template;
